import { Badge } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { ExpenseStatusEnum } from "@src/__generated__/urql-graphql";
import type { FC } from "react";

export const ExpenseStatusBadge: FC<{ status: ExpenseStatusEnum }> = ({
  status,
}) => {
  switch (status) {
    case ExpenseStatusEnum.Draft:
      return (
        <Badge color="text-gray-500" fontSize="xx-small" colorScheme="grey">
          <Trans>Draft</Trans>
        </Badge>
      );
    case ExpenseStatusEnum.ForApproval:
      return (
        <Badge fontSize="xx-small" colorScheme="yellow">
          <Trans>For approval</Trans>
        </Badge>
      );
    case ExpenseStatusEnum.ForFinancialApproval:
      return (
        <Badge fontSize="xx-small" colorScheme="orange">
          <Trans>For financial approval</Trans>
        </Badge>
      );
    case ExpenseStatusEnum.Approved:
      return (
        <Badge fontSize="xx-small" colorScheme="green">
          <Trans>Approved</Trans>
        </Badge>
      );
    default:
      return null;
  }
};
